/**
 * 商城 - 商品详情
 * 电商风格：banner、价格、评价等，无需登录；点击购买弹窗提示领券+客服二维码
 */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Modal } from 'antd';
import mallBannerImg from 'asset/img/mall_banner.png';
import './ProductDetail.scss';

const QRCODE_CUSTOMER_SERVICE = `${process.env.PUBLIC_URL || ''}/qrcode-customer-service.png`;

// 星级展示：支持 3.5 / 4 / 4.5 / 5，半星用 ☆ 表示
const renderStars = (star) => {
  const s = star ?? 5;
  const full = Math.floor(s);
  const hasHalf = s % 1 >= 0.5;
  return '★'.repeat(full) + (hasHalf ? '☆' : '');
};

// 静态商品详情（后续可接接口）
const PRODUCTS_MAP = {
  vip: {
    id: 'vip',
    name: '悟空听说-7年听说能力养成计划',
    subtitle: '7年系统陪伴 · 听说优先 · 自然开口',
    banner: [mallBannerImg],
    price: 6980,
    priceLabel: '¥6980',
    priceOriginal: '¥7980', // 优惠前
    sales: '5100+',
    promotion: '拍5年送2年',
    desc: '立即获取长期学习权益即可畅享全部课程与功能，和悟空一起快乐学英语。右脑记忆法+情境闯关，听说先行，坚持一段时间就能开口说。',
    // 主信息区展示：多人评价 + 一条高亮评价标签（引号内）
    reviewSummaryTag: '右脑记忆好用',
    // 服务/权益（虚拟商品）
    services: ['立即开通', '7天无理由退款', '专属班主任'],
    // 评价标签：文案 + 数量（与评价内容对应，用于顶部标签展示）
    reviewTags: [
      { label: '右脑记忆好用', count: 12 },
      { label: '孩子爱学', count: 9 },
      { label: '开口快', count: 6 },
      { label: '性价比高', count: 5 },
    ],
    reviews: [
      { user: '匿名用户', star: 5, text: '我带的孙子，每天放学回来就要打开悟空学。我也不会英语，就陪着他听，听了两个多月吧，现在能跟着说简单的句子了，右脑记忆那套真的有用，记单词比死记快多了。', time: '2024-03-12' },
      { user: '138****5621', star: 5, text: '妈妈党一枚，最怕孩子哑巴英语。用这个听了三个月，孩子开始主动往外蹦单词，虽然还不成句，但敢说了，老母亲很欣慰。', time: '2024-03-10' },
      { user: 'Zhangwei', star: 5, text: '平时工作忙，周末陪娃闯关。娃说右脑记东西像看图一样，比学校那种反复抄写轻松。已经续费了。', time: '2024-03-08' },
      { user: '匿名用户', star: 4.5, text: '外孙女 5 岁，我带着学的。她特别喜欢悟空，每天要喂悟空、闯关，听了大概一个半月，会唱里面的英文儿歌了，发音还挺像那么回事。', time: '2024-03-05' },
      { user: '159****3087', star: 5, text: '没时间送线下班，就靠每天 15 分钟听。坚持了四个月，孩子从不敢开口到现在能跟读整段，右脑记忆确实比硬背强。', time: '2024-03-01' },
      { user: 'Lili妈妈', star: 4, text: '老大用了半年，老二也跟着蹭。老大已经能简单对话了，老二听了两个月也开始模仿，性价比可以。', time: '2024-02-28' },
      { user: '186****9901', star: 4.5, text: '听了 50 多天，孩子从完全不说到能跟读句子，老师说进步明显。右脑那部分我们家长也看不懂，但娃喜欢，有效果就行。', time: '2024-02-25' },
      { user: '匿名用户', star: 5, text: '冲着右脑记忆来的，娃记单词明显比之前快，而且不容易忘。听了三个月开口多了，会主动说 apple、banana 那种。', time: '2024-02-22' },
      { user: 'wangyan_', star: 4.5, text: '我文化不高，带孙子学英语就靠这个。每天固定时间听，他当玩游戏一样，两个月就能跟读短句了，我觉得很值。', time: '2024-02-18' },
      { user: '177****4432', star: 5, text: '妈妈群里推荐的，说听了能开口。我们用了快四个月，娃从零基础到能说简单句型，发音也比我想象中好。', time: '2024-02-15' },
      { user: '匿名用户', star: 4, text: '之前线下课一年都不敢说，换这个听了两个多月，突然开始往外冒英语，虽然简单但敢说了，右脑记忆那块孩子特别感兴趣。', time: '2024-02-12' },
      { user: 'xiaoming_mama', star: 5, text: '每天打卡，已经 80 多天了。孩子从跟读到能自己说几句，进步看得见。右脑记忆我们也不懂原理，反正娃喜欢、有效。', time: '2024-02-08' },
      { user: '131****7765', star: 4.5, text: '爷爷带孙女，她妈妈买的7年成长通关计划。我负责每天给她放，听了大概三个月，会唱好几首英文歌了，还会跟悟空对话那种，挺神奇的。', time: '2024-02-05' },
      { user: '匿名用户', star: 5, text: '真的听了大概两个月就开始开口，之前完全不肯说英语。现在会主动说 I like…、This is… 那种，老母亲感动。', time: '2024-02-01' },
      { user: 'Chen**', star: 4.5, text: '右脑记忆强大是真的，娃记句子比记单词还快，可能是图像+声音一起的关系。听了四个月，能简单对话了。', time: '2024-01-28' },
      { user: '152****2109', star: 4, text: '姥姥带外孙，不会英语就陪听。孩子当游戏玩，听了快三个月，能跟读长句了，还会自己造简单句，右脑那个我们不懂但娃进步大。', time: '2024-01-25' },
      { user: '匿名用户', star: 5, text: '自己英语一般，怕教坏发音。用这个纯听+跟读，孩子听了两个半月开始主动说，发音反而比我还标准，省心。', time: '2024-01-20' },
      { user: 'Liuwei', star: 4.5, text: '最满意的是娃主动要学，每天到点就说要闯关。听了三个月开口明显多了，右脑记忆那块记东西特别快。', time: '2024-01-15' },
      { user: '188****6543', star: 4, text: '奶奶带娃学英语，就靠这个。每天 20 分钟，听了两个多月，孩子能说简单句子了，我觉得比报班划算。', time: '2024-01-10' },
      { user: '匿名用户', star: 5, text: '用了整整三个月，从不敢开口到能跟读、能简单对话。右脑记忆法名不虚传，娃记单词句子都很快，推荐。', time: '2024-01-05' },
      { user: 'Yang**', star: 3.5, text: '老大用了能开口，老二也跟着听。听了大概 50 天，老二开始蹦单词和短句，右脑记忆对小孩确实友好。', time: '2024-01-02' },
      { user: '136****8876', star: 4.5, text: '听说先行真的有用，先听够了再开口，孩子不抵触。我们听了四个月，现在能简单交流，奶奶带的也能跟上。', time: '2023-12-28' },
      { user: '匿名用户', star: 4, text: '真实用户，孩子 6 岁，听了三个月多，从零到能说短句。右脑记忆那块我们家长看不懂，但娃喜欢、记得牢，够了。', time: '2023-12-22' },
      { user: '139****3321', star: 5, text: '同事推荐的，说右脑记忆对小孩管用。试了两个月，娃记单词确实快，还会主动跟读，准备长期用。', time: '2023-12-18' },
      { user: 'Huangxin', star: 4.5, text: '外婆带娃，完全不懂英语。就每天放给他听，一个多月会唱几首英文歌了，发音我听着挺准的。', time: '2023-12-14' },
      { user: '匿名用户', star: 4, text: '线下课太贵了，试了这个。每天十几分钟，坚持三个月，孩子敢开口了，性价比高。', time: '2023-12-10' },
      { user: '158****9012', star: 5, text: '娃 5 岁，零基础。听了两个月开始蹦单词，三个月能跟读短句，右脑那个模块他特别喜欢。', time: '2023-12-06' },
      { user: 'Zhou**', star: 3.5, text: '妈妈上班忙，奶奶带着学。奶奶说不用她教，孩子自己跟着悟空学，两个月就能说简单句子了。', time: '2023-12-02' },
      { user: '匿名用户', star: 4.5, text: '之前买过别的 app，孩子不爱学。换这个以后每天主动要闯关，听了 50 多天就开始往外说英语了。', time: '2023-11-28' },
      { user: '183****5544', star: 5, text: '右脑记忆法名不虚传，娃记东西快还不爱忘。听了四个月能简单对话了，比线下班省钱多了。', time: '2023-11-24' },
      { user: 'Sunlei', star: 4, text: '二胎家庭，老大用了半年能简单交流，老二 4 岁跟着听，两个月也会唱英文歌了。', time: '2023-11-20' },
      { user: '匿名用户', star: 4.5, text: '孩子以前不敢说英语，用了这个三个月，突然就敢说了。虽然句子简单，但进步明显。', time: '2023-11-16' },
      { user: '151****7788', star: 5, text: '每天固定时间听，养成习惯以后不用催。听了两个半月，从零到能跟读，右脑记忆那块确实有用。', time: '2023-11-12' },
      { user: 'Wu**', star: 4, text: '爷爷带孙女学，我负责每天放。她当游戏玩，三个月会唱好几首英文歌，还会跟读句子。', time: '2023-11-08' },
      { user: '匿名用户', star: 4.5, text: '妈妈党，最看重能开口。听了四个月，孩子从哑巴英语到能说短句，发音也比我想象中好。', time: '2023-11-04' },
      { user: '137****2233', star: 5, text: '冲着 7 年成长通关计划买的，拍 5 送 2 划算。娃喜欢悟空，每天要闯关，听了两个月就开始开口了。', time: '2023-10-30' },
      { user: 'Lina_bb', star: 4, text: '奶奶带孙子，不会英语。就陪着他听，两个月能跟读短句，三个月会唱儿歌，很满意。', time: '2023-10-26' },
      { user: '匿名用户', star: 5, text: '右脑记忆对小孩友好，记单词快。听了三个月开口多了，会主动说 apple、banana 那种。', time: '2023-10-22' },
      { user: '189****6655', star: 4.5, text: '职场妈妈，没时间送班。每天 15 分钟听，四个月孩子能跟读整段了，省心。', time: '2023-10-18' },
      { user: 'Zheng**', star: 3.5, text: '老大用了能开口，老二也跟着蹭。听了 50 天老二开始蹦词，右脑记忆对小孩确实友好。', time: '2023-10-14' },
      { user: '匿名用户', star: 4, text: '老师反馈孩子进步大，问我们在家怎么学的。就用的这个，每天听一会儿，坚持三个月。', time: '2023-10-10' },
      { user: '156****4123', star: 4.5, text: '姥姥带外孙学，不会英语就陪听。孩子当游戏玩，快三个月能跟读长句了，还会自己造简单句。', time: '2023-10-06' },
      { user: 'Xuemei', star: 5, text: '听说先行有用，孩子不抵触。听了四个月能简单交流，奶奶带的也能跟上进度。', time: '2023-10-02' },
      { user: '匿名用户', star: 4, text: '娃主动要学，每天到点就说要闯关。右脑记忆那块记东西特别快，听了三个月开口明显多了。', time: '2023-09-28' },
      { user: '133****9087', star: 4.5, text: '之前线下一年不敢说，换这个两多月突然开始冒英语。虽然简单但敢说了，满意。', time: '2023-09-24' },
      { user: 'Ma**', star: 4, text: '每天打卡 80 多天了，从跟读到能自己说几句。右脑记忆我们不懂原理，娃喜欢、有效就行。', time: '2023-09-20' },
      { user: '匿名用户', star: 5, text: '孩子 6 岁，听了三个月从零到能说短句。右脑记忆我们家长看不懂，但娃记得牢，够了。', time: '2023-09-16' },
      { user: '178****3210', star: 4.5, text: '妈妈群里推荐的，用了四个月娃从零基础到能说简单句型。发音比我想象中好，性价比高。', time: '2023-09-12' },
      { user: 'Jingjing', star: 4, text: '外婆带外孙女，我买的7年成长通关计划。她每天放给娃听，一个半月会唱英文儿歌了，发音还挺准。', time: '2023-09-08' },
      { user: '匿名用户', star: 5, text: '冲着右脑记忆来的，娃记单词比之前快还不爱忘。听了三个月开口多了，会续费。', time: '2023-09-04' },
      { user: '135****6789', star: 4.5, text: '爸爸周末陪闯关，娃说右脑记东西像看图。比学校反复抄写轻松，已经续费了。', time: '2023-08-30' },
      { user: 'Lin**', star: 4, text: '二宝家庭，老大用了能简单对话，老二听了两个月也模仿。一个7年成长通关计划俩娃用，划算。', time: '2023-08-26' },
      { user: '匿名用户', star: 5, text: '老师表扬孩子进步明显，我们就在家每天听这个。50 多天从完全不说到能跟读句子。', time: '2023-08-22' },
      { user: '182****1098', star: 4.5, text: '奶奶文化不高，带孙子学英语就靠这个。每天固定时间听，两个月能跟读短句，很值。', time: '2023-08-18' },
      { user: '匿名用户', star: 5, text: '用了整整三个月，从不敢开口到能跟读能简单对话。右脑记忆法娃记单词句子都很快。', time: '2023-08-14' },
      { user: 'Guo**', star: 4, text: '孩子以前不肯说英语，用了两个月突然开始开口。现在会主动说 I like、This is 那种。', time: '2023-08-10' },
      { user: '147****5543', star: 4.5, text: '妈妈英语一般，怕教坏发音。用这个纯听跟读，两个半月孩子开始主动说，发音比我还标准。', time: '2023-08-06' },
      { user: '匿名用户', star: 5, text: '右脑记忆强大，娃记句子比记单词还快。听了四个月能简单对话了，推荐。', time: '2023-08-02' },
    ],
  },
};

const ProductDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [product, setProduct] = useState(null);
  const [couponModalVisible, setCouponModalVisible] = useState(false);

  useEffect(() => {
    const data = PRODUCTS_MAP[id];
    if (data) setProduct(data);
    else setProduct(null);
  }, [id]);

  if (product === undefined) {
    return (
      <div className="mall-detail-page">
        <div className="mall-detail__loading">加载中...</div>
      </div>
    );
  }
  if (!product) {
    return (
      <div className="mall-detail-page">
        <div className="mall-detail__empty">
          <p>商品不存在</p>
          <button type="button" className="mall-detail__back-btn" onClick={() => navigate('/mall')}>返回商城</button>
        </div>
      </div>
    );
  }

  const banners = Array.isArray(product.banner) ? product.banner : [product.banner];

  return (
    <div className="mall-detail-page">
      <header className="mall-detail-header">
        <span className="mall-detail-header__back" onClick={() => navigate(-1)} aria-label="返回">
          ← 返回
        </span>
        <h1 className="mall-detail-header__title">商品详情</h1>
      </header>

      <section className="mall-detail-banner">
        {banners.length > 0 ? (
          <img src={banners[0]} alt={product.name} />
        ) : (
          <div className="mall-detail-banner__placeholder">暂无主图</div>
        )}
      </section>

      <section className="mall-detail-main">
        <div className="mall-detail-name">{product.name}</div>
        {product.subtitle && <div className="mall-detail-subtitle">{product.subtitle}</div>}
        {product.promotion && (
          <div className="mall-detail-promotion">{product.promotion}</div>
        )}
        <div className="mall-detail-meta">
          {product.sales && <span className="mall-detail-meta__sales">已售 {product.sales}</span>}
          <span className="mall-detail-meta__pipe">|</span>
          <span className="mall-detail-meta__review">多人评价</span>
          {product.reviewSummaryTag && (
            <span className="mall-detail-meta__tag">「{product.reviewSummaryTag}」</span>
          )}
        </div>
        <div className="mall-detail-price-wrap">
          <span className="mall-detail-price-label">券后</span>
          <span className="mall-detail-price">{product.priceLabel}</span>
          {product.priceOriginal && (
            <span className="mall-detail-price-original">{product.priceOriginal}</span>
          )}
        </div>
        {product.services && product.services.length > 0 && (
          <div className="mall-detail-services">
            {product.services.map((s, i) => (
              <span key={i} className="mall-detail-service-item">{s}</span>
            ))}
          </div>
        )}
        {product.desc && <div className="mall-detail-desc">{product.desc}</div>}
      </section>

      <section className="mall-detail-reviews">
        <h3 className="mall-detail-reviews__title">用户评价 · {product.reviews ? product.reviews.length : 0}</h3>
        {product.reviewTags && product.reviewTags.length > 0 && (
          <div className="mall-detail-reviews__tags">
            {product.reviewTags.map((tag, i) => (
              <span key={i} className="mall-detail-review-tag">{tag.label} {tag.count}</span>
            ))}
          </div>
        )}
        {product.reviews && product.reviews.length > 0 ? (
          <>
            <ul className="mall-detail-reviews-list">
              {product.reviews.map((r, i) => (
                <li key={i} className="mall-detail-review-item">
                  <div className="mall-detail-review-item__head">
                    <span className="mall-detail-review-item__user">{r.user}</span>
                    <span className="mall-detail-review-item__star">{renderStars(r.star)}</span>
                  </div>
                  <p className="mall-detail-review-item__text">{r.text}</p>
                  <div className="mall-detail-review-item__time">{r.time}</div>
                </li>
              ))}
            </ul>
            {/* <div className="mall-detail-reviews__footer">
              <button type="button" className="mall-detail-reviews__all-btn">查看全部评价</button>
            </div> */}
          </>
        ) : (
          <div className="mall-detail-reviews__empty">暂无评价</div>
        )}
      </section>

      <footer className="mall-detail-footer">
        <button
          type="button"
          className="mall-detail-footer__btn"
          onClick={() => setCouponModalVisible(true)}
        >
          立即购买 {product.priceLabel}
        </button>
      </footer>

      <Modal
        title={null}
        open={couponModalVisible}
        onCancel={() => setCouponModalVisible(false)}
        footer={null}
        closable={true}
        centered
        width={340}
        className="mall-coupon-modal"
        styles={{ body: { padding: '24px 20px' } }}
      >
        <div className="mall-coupon-modal__content">
          <p className="mall-coupon-modal__tip">优惠价格已过期，请联系客服老师领券</p>
          <div className="mall-coupon-modal__qrcode-wrap">
            <img src={QRCODE_CUSTOMER_SERVICE} alt="联系客服领券" className="mall-coupon-modal__qrcode" />
          </div>
          <p className="mall-coupon-modal__hint">扫码添加客服，领取优惠券</p>
        </div>
      </Modal>
    </div>
  );
};

export default ProductDetail;
